import { MetronomeIcon } from './MetronomeIcon';

/**
 * author: Haley Halcyon
 * id 13256CBF-E284-4229-AAB9-5612FBADD060
 * name metronome
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/metronome.svg
 * tags
 * - Music 
 */
export const BpmIcon = MetronomeIcon;
export default BpmIcon